import { render, staticRenderFns } from "./DocumentationUsedIn.vue?vue&type=template&id=36de1557&"
import script from "./DocumentationUsedIn.vue?vue&type=script&lang=js&"
export * from "./DocumentationUsedIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports